module.exports = __webpack_public_path__ + "static/media/ReportPromoCodeIcon.47fabd97.svg";